import * as Sentry from '@sentry/browser';
export const errorService = (error, extra) => {
  if (process.env.REPORT_SERVICE) {
    Sentry.withScope(scope => {
      scope.setExtras(extra);
      Sentry.captureException(error);
    });
  } else {
    console.log(error);
  }
};
